export const exitTheSystem="Are you sure you want to exit the system?";
export const onlyAvailable1="This function is only available when the taxpayer status is registered.";
export const onlyAvailable2="This function is only available when at least one headquarter/branch status is registered and effective.";
export const onlyAvailable3="This function is only available when at least one headquarter/branch’s E-invocing status is registered and effective.";
export const canNotIssue="You can't issue invoice through this channel, please contact URA.";
export const pleaseRegisterFirst="Please register first in ICS.";
export const english="English";
export const chinese="中文";
export const siteMap="Site Map";
export const contactUs="Contact Us";
export const guideline="My-invoice Guideline";
export const searchPolicy="Search Policy or FAQs";
export const searchFunction="Search Function";
export const viewProfile="View My Profile";
export const modifyPassword="Modify Password";
export const language="语言";
export const next="Next";
export const skip="Skip";
export const policy="Policy";
export const yes="Yes";
export const no="No";
export const logout="Logout";
export const publicMenuArea="Public menu area";
export const home="Home";
export const eInvoicing="e-Invoicing";
export const performance="Performance";
export const userGuides="User Guides";
export const FAQs="FAQs";
export const leftMenu="Left menu: Main operating function area";
export const message="message:View your received message";
export const visitorNumber="You are visitor number:";
export const lastUpdate="Last Update:";
export const upToDate="Are your EFD/e-Invoicing registration details below up-to-date?";
export const title="Title";
export const summary="Summary";
export const source="Source";
export const releaseDate="Release Date";
export const enterBusinessSystemOrRemarks="Enter Business System or Remarks";
export const myCompany="My Company";
export const maintainTheBusinessSystem="Please maintain the business system.";
export const idTypeNotMatchTIN="The ID Type or ID Value does not match the TIN.";
export const selectTheBusinessSystem="Please select the business system.";
export const notCustomizedTemplate="You have not yet customized the PDF, please contact MyInvoice2U.";
